import React, { useState } from "react";
import CustomTimePicker from "./CustomTimePicker";
import FullFeaturedCrudGrid from "./FullFeaturedCrudGrid";
import { Habit, db } from "../services/db";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { v4 as uuidv4 } from "uuid";
import ColorPicker from "./ColorPicker";
import { ColorResult } from "react-color";

export default function CreateNewArc({
  setArcs,
  arcs,
  setShowForm,
  setUpdated,
}: any) {
  const [arcName, setArcName] = useState("");
  const [timePeriod, setTimePeriod] = useState("");
  const [habits, setHabits] = useState<Habit[]>([]);
  const [newHabit, setNewHabit] = useState("");
  const [step, setStep] = useState(1);

  const [uuidarcId, setUuidArcID] = useState("");

  const today = new Date();
  const defaultStartDate = today.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
  const [startDate, setStartDate] = useState<Date>(new Date(defaultStartDate));
  const handleArcNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setArcName(event.target.value);
  };

  const handleTimePeriodChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTimePeriod(event.target.value);
  };

  const handleNextStep = () => {
    setStep(2);
  };

  const handlePreviousStep = () => {
    setStep(1);
  };

  const handleSubmitFirstStep = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const arcId = uuidv4();
    setUuidArcID(arcId);
    handleNextStep();
  };

  const arcId = uuidv4();

  console.log("arcId: ", arcId);
  const renderHabits = (habits: Habit[]) => {
    return (
      <div className="w-3/6 flex flex-col items-start">
        {habits.map((habit: Habit, index: number) => (
          <div
            key={index}
            className="p-2 bg-slate-400 items-center rounded-lg my-2 w-full flex justify-between"
          >
            {habit.isEditing ? (
              <div>
                <input
                  type="text"
                  value={habit.name}
                  onChange={(e) => handleHabitNameChange(index, e.target.value)}
                  className="input input-bordered mt-1 block w-full"
                />
                {/* <div className="mt-4">
                  <CustomTimePicker
                    hour={habit.timeOfDay.hour}
                    minute={habit.timeOfDay?.minute}
                    onHourChange={(newHour) =>
                      handleHabitHourChange(index, newHour.target.value)
                    }
                    onMinuteChange={(newMinute) =>
                      handleHabitMinuteChange(index, newMinute.target.value)
                    }
                  />
                </div> */}
              </div>
            ) : (
              <span className="pl-2 rounded-3xl">{habit.name}</span>
            )}
            <button
              onClick={() => handleEditHabit(index)}
              className="ml-2 btn btn-sm btn-secondary text-right"
            >
              {habit.isEditing ? "Save" : "Edit"}
            </button>
          </div>
        ))}
      </div>
    );
  };

  const handleEditHabit = (index: number) => {
    const updatedHabits = [...habits];
    updatedHabits[index].isEditing = !updatedHabits[index].isEditing;
    setHabits(updatedHabits);
  };

  const handleHabitNameChange = (index: number, newName: string) => {
    const updatedHabits = [...habits];
    updatedHabits[index] = { ...updatedHabits[index], name: newName };
    setHabits(updatedHabits);
  };

  const handleHabitHourChange = (index: number, newHour: string) => {
    const updatedHabits = [...habits];
    if (updatedHabits[index].timeOfDay) {
      updatedHabits[index].timeOfDay.hour = newHour;
    }
    console.log("updatedHabits:: ", updatedHabits);
    setHabits(updatedHabits);
  };

  const handleHabitMinuteChange = (index: number, newMinute: string) => {
    const updatedHabits = [...habits];
    if (updatedHabits[index].timeOfDay) {
      updatedHabits[index].timeOfDay.minute = newMinute;
    }
    console.log("updatedHabits:: ", updatedHabits);

    setHabits(updatedHabits);
  };

  const handleSubmitHabit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    let count = 0;

    // Initialize the new habit object
    const newHabitObject: Habit = {
      id: uuidv4(),
      arcId: uuidarcId,
      name: newHabit,
      timeOfDay: { hour: hour, minute: minute },
      completed: {},
    };

    const endDate = new Date(
      startDate.getTime() + parseInt(timePeriod) * 24 * 60 * 60 * 1000
    );

    let date = new Date(startDate); // Initialize date with the startDate value

    while (count < Number(timePeriod)) {
      count++;
      const dateString = date.toLocaleDateString();
      newHabitObject.completed[dateString] = false;

      // Move to the next date
      date.setDate(date.getDate() + 1);
    }

    // Add the new habit to the state
    setHabits([...habits, newHabitObject]);
    setNewHabit("");
  };

  const [hour, setHour] = useState<string>("10");
  const [minute, setMinute] = useState<string>("10");

  const [color, setColor] = useState<ColorResult>({
    "rgb": { "r": 19, "g": 112, "b": 241, "a": 1 },
    "hex": "#1370F1",
    "hsl": { "h": 218.23529411764707, "s": 0.87, "l": 0.51, "a": 1 }
}
);

  const handleHourChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setHour(e.target.value);
  };

  const handleMinuteChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setMinute(e.target.value);
  };

  console.log("color:: ", color);

  return (
    <div className="flex w-full justify-center items-center">
      {" "}
      {/* Light color theme */}
      <div className="w-full">
        <br />
        {step !== 2 && (
          <div className="w-full flex flex-col justify-start items-center text-left">
            <form
              onSubmit={handleSubmitFirstStep}
              className="w-full flex flex-col justify-start items-center"
            >
              <label className="block mb-2 w-3/6">
                Name
                <input
                  type="text"
                  value={arcName}
                  onChange={handleArcNameChange}
                  className="input input-bordered mt-1 block w-full"
                  required
                />
              </label>
              <label className="block mb-2 w-3/6">
                Number of Days
                <input
                  type="number"
                  value={timePeriod}
                  onChange={handleTimePeriodChange}
                  className="input input-bordered mt-1 block w-full"
                  required
                />
              </label>
              <label className="mb-2 w-3/6 flex flex-col">
                <span>Start Date </span>
                <DatePicker
                  selected={startDate}
                  onChange={(date: Date) => setStartDate(date)}
                  className="input input-bordered mt-1 block w-full"
                  placeholderText="Select start date..."
                  dateFormat="dd MMMM yyyy"
                  todayButton="Today"
                  required
                />
              </label>

              <label className="mb-2 w-3/6 flex flex-col">
                <span>Color for your challenge </span>
                <ColorPicker color={color} setColor={setColor} />
              </label>

              <button type="submit" className="btn w-3/6 btn-primary mt-4">
                Next
              </button>
            </form>
          </div>
        )}

        {step === 2 && (
          <div className="flex flex-col justify-center">
            <div className="w-full flex flex-col justify-start items-center text-left">
              {renderHabits(habits)}
              <form
                onSubmit={handleSubmitHabit}
                className="w-full flex flex-col justify-start items-center"
              >
                <div className="w-3/6 flex items-center justify-center gap-4 mb-4">
                  <div className="flex-1 flex items-center justify-center">
                    <input
                      type="text"
                      value={newHabit}
                      placeholder="Enter your Habit..."
                      onChange={(e) => setNewHabit(e.target.value)}
                      className="input input-bordered mt-1 block w-full"
                      required
                    />
                  </div>
                  {/* <span>Start Date: </span>
                  <CustomTimePicker
                    hour={hour}
                    minute={minute}
                    onHourChange={handleHourChange}
                    onMinuteChange={handleMinuteChange}
                  /> */}
                </div>
                <div className="flex gap-4">
                  <button
                    className="btn btn-primary"
                    onClick={handlePreviousStep}
                  >
                    Back
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Add Habit
                  </button>
                  <button
                    className="bg-green-500 btn"
                    onClick={async () => {
                      setShowForm(false);
                      setUpdated((prev: any) => setUpdated(!prev));
                      db.addArc(
                        arcName,
                        uuidarcId,
                        timePeriod,
                        startDate,
                        habits,
                        color.hex
                      );
                      window.location.reload();

                      console.log(">> ", await db.getAllArcs());
                    }}
                  >
                    Save Challenge
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
